var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTrafficLights = function SvgTrafficLights(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 21.3945C19.864 21.3945 21.375 19.8835 21.375 18.0195C21.375 16.1556 19.864 14.6445 18 14.6445C16.136 14.6445 14.625 16.1556 14.625 18.0195C14.625 19.8835 16.136 21.3945 18 21.3945Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.3945C19.864 12.3945 21.375 10.8835 21.375 9.01953C21.375 7.15557 19.864 5.64453 18 5.64453C16.136 5.64453 14.625 7.15557 14.625 9.01953C14.625 10.8835 16.136 12.3945 18 12.3945Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 30.3945C19.864 30.3945 21.375 28.8835 21.375 27.0195C21.375 25.1556 19.864 23.6445 18 23.6445C16.136 23.6445 14.625 25.1556 14.625 27.0195C14.625 28.8835 16.136 30.3945 18 30.3945Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.875 1.14453H13.125C11.4681 1.14453 10.125 2.48768 10.125 4.14453V31.8945C10.125 33.5514 11.4681 34.8945 13.125 34.8945H22.875C24.5319 34.8945 25.875 33.5514 25.875 31.8945V4.14453C25.875 2.48768 24.5319 1.14453 22.875 1.14453Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1248 5.64453H4.84029C4.52572 5.64447 4.21947 5.74563 3.96683 5.93307C3.71419 6.1205 3.52856 6.38425 3.4374 6.68533C3.34624 6.98641 3.35437 7.30883 3.4606 7.60492C3.56683 7.90102 3.76552 8.15508 4.02729 8.32953L10.1248 12.3945",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1248 14.6445H4.84029C4.52572 14.6445 4.21947 14.7456 3.96683 14.9331C3.71419 15.1205 3.52856 15.3843 3.4374 15.6853C3.34624 15.9864 3.35437 16.3088 3.4606 16.6049C3.56683 16.901 3.76552 17.1551 4.02729 17.3295L10.1248 21.3945",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1248 23.6445H4.84029C4.52572 23.6445 4.21947 23.7456 3.96683 23.9331C3.71419 24.1205 3.52856 24.3843 3.4374 24.6853C3.34624 24.9864 3.35437 25.3088 3.4606 25.6049C3.56683 25.901 3.76552 26.1551 4.02729 26.3295L10.1248 30.3945",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.875 5.64453H31.1595C31.4741 5.64447 31.7803 5.74563 32.033 5.93307C32.2856 6.1205 32.4712 6.38425 32.5624 6.68533C32.6536 6.98641 32.6454 7.30883 32.5392 7.60492C32.433 7.90102 32.2343 8.15508 31.9725 8.32953L25.875 12.3945",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.875 14.6445H31.1595C31.4741 14.6445 31.7803 14.7456 32.033 14.9331C32.2856 15.1205 32.4712 15.3843 32.5624 15.6853C32.6536 15.9864 32.6454 16.3088 32.5392 16.6049C32.433 16.901 32.2343 17.1551 31.9725 17.3295L25.875 21.3945",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.875 23.6445H31.1595C31.4741 23.6445 31.7803 23.7456 32.033 23.9331C32.2856 24.1205 32.4712 24.3843 32.5624 24.6853C32.6536 24.9864 32.6454 25.3088 32.5392 25.6049C32.433 25.901 32.2343 26.1551 31.9725 26.3295L25.875 30.3945",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrafficLights, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/TrafficLights.0706305b.svg";
export { ForwardRef as ReactComponent };